import React, { Component } from 'react';
import * as Questions from './questions'

export const GlobalExecSum = (props) => {
    const { topSections, midSections, bottomSections } = Questions.sectionsRequiringActions(props.tree.sections)  
    return (
        <div>
            <p>
                {props.tree.percentage >= 0.75 && 
                    'Parabéns! A sua empresa parece encontrar-se num estágio bastante avançado no que diz respeito a simbiose de Sustentabilidade + Rentabilidade'
                    }
                {between(props.tree.percentage, 0.5, 0.75) && 
                    'Parabéns! A sua empresa parece encontrar-se num estágio relativamente avançado no que diz respeito a simbiose de Sustentabilidade + Rentabilidade'
                    }
                {between(props.tree.percentage, 0.25, 0.5) && 
                    'Parece que já desenvolveu várias iniciativas nas vertentes de Sustentabilidade e Circularidade.'
                    }
                {between(props.tree.percentage, 0, 0.25) && 
                    'Parece encontrar-se num estágio inicial nas vertentes de Sustentabilidade e Circularidade.'
                    }
            </p>
        
            {  (midSections.length > 0 || bottomSections.length > 0) &&
                <span>
                    <p>Contudo, ainda tem oportunidades de melhoria em:</p>
                    <ul>
                        { midSections.map(section => section.title).map( (title, offset) => 
                            <li key={offset}>
                                {title}
                            </li>
                            )
                        }
                        { bottomSections.map(section => section.title).map( (title, offset) => 
                            <li key={offset}>
                                {title}
                            </li>
                            )
                        }
                    </ul>
                </span>
                
            }
            
            <p>
               Tendo em vista a melhoria simultânea da Rentabilidade e da Sustentabilidade, neste relatório são indicadas:
            </p>
            <ul>
                <li>
                    As pontuações parciais por área analisada
                </li>
                <li>
                    Uma lista de acções de melhoria a considerar
                </li>
            </ul>
                
            
        </div>
    )
}

const between = (value, lowThreshold, highThreshold) => value >= lowThreshold && value < highThreshold

export const SectionExecSum = (props) => {
    const { topSections, midSections, bottomSections } = Questions.sectionsRequiringActions(props.tree.sections) 
    let __sectionTitle = section => section.title
    let topSectionTitles = topSections.map(__sectionTitle)
    let midSectionTitles = midSections.map(__sectionTitle)
    let bottomSectionTitles = bottomSections.map(__sectionTitle)

    let topText = `Está de parabéns pelo que já fez nas vertentes de ${verboseJoin(topSectionTitles)}. `
    let midText = `${topSections.length > 0? 'Também' : 'Já'} deu bons passos nas áreas de ${verboseJoin(midSectionTitles)}. `
    let bottomText = `${topSections.length > 0 || midSections.length > 0? 'Contudo, tem' : 'Tem'} oportunidades de melhoria em ${verboseJoin(bottomSectionTitles, ', ', 'e')}. `

    return (
        <p>
            {topSections.length > 0 && topText}
            {midSections.length > 0 && midText}
            {bottomSections.length > 0 && bottomText}
        </p>
    )
}

export const SubSectionExecSum = (props) => {
    return props.tree.sections.map( (section, sectionOffset) => {
        let relevantSubSections = section.subSections.filter( subSection => subSection.score < 0.5).filter(subSection => subSection.title)
        let subSectionTitles = relevantSubSections.map(subSection => subSection.title)
        if (relevantSubSections.length > 0) return (
            <p key={sectionOffset}>
                Em relação a {section.title}, há oportunidade desenvolver iniciativas em torno de {verboseJoin(subSectionTitles)}
            </p>
        )
    })
}

export const StageExecSum = (props) => {
    return props.tree.sections.map( section => {
        return section.subSections.filter( subSection => subSection.score < 0.5).map( subSection => {
            return (
                <p>
                    Em relação a {subSection.title? subSection.title : section.title}, há oportunidade desenvolver iniciativas em torno de {verboseJoin(subSection.stages.map(stage => stage.title))}
                </p>
            )
        })    
    })
}

const verboseJoin = (array, separator = ', ', finalSeparator = 'e') => (
    array.length > 1 ? 
        `${array.slice(0, array.length - 1).join(separator)} ${finalSeparator} ${array.slice(-1)[0]}`
        : array[0]

)

    


// WEBPACK FOOTER //
// ./src/ExecSums.jsx